export default {
  LOADING: 'LOADING_DELIVERY',
  BUTTON_LOADING: 'BUTTON_DELIVERY',
  CHECK_LOADING: 'CHECK_LOADING',
  CHECK_FETCHED: 'CHECK_FETCHED',
  STATUS_FETCHED: 'STATUS_FETCHED',
  DELIVERY_GROCERY_LIST_LOAD: 'DELIVERY_GROCERY_LIST_LOAD',
  DELIVERY_GROCERY_LIST_FETCHED: 'DELIVERY_GROCERY_LIST_FETCHED',
};
